<!--
小于胎龄儿患者各类风险因素占比统计
-->
<template>
  <div class="container">
    <div style="background-color: #fff; padding: 12px 0">
      <div class="my-font-size-16 my-weight-500 titleBox" style="margin: 0 12px">
        <div class="my-primary-color">
          {{ $t('home.sga_risk_rate')}}
        </div>
        <div>···</div>
      </div>
      <a-divider></a-divider>
      <div class="my-primary-margin">
        <div id="sgaRiskRate" :class="className" :style="{ height: height, width: width }" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'SgaRiskRate',
  components: {},
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      chart: null,
      chartData: {}
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.getChartData()
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getChartData () {
      this.loading = true
      this.$get('web/chartData/getSgaData').then((r) => {
        let data = r.data
        if (data.code === 200) {
          if (data.data) {
            this.chartData = data.data
          }
          this.$forceUpdate()
        } else {
          this.$message.error(data.message)
        }
        this.loading = false
      })
    },
    initChart () {
      this.chart = echarts.init(document.getElementById('sgaRiskRate'))
      this.setOptions(this.chartData)
    },
    setOptions ({ titleList, dataList, dataList2 } = {}) {
      let max = 10
      if (dataList) {
        dataList.forEach(element => {
          if (element > max) {
            max = Math.ceil(element / 10) * 10 + 10
          }
        })
      }
      if (dataList2) {
        dataList2.forEach(element => {
          if (element > max) {
            max = Math.ceil(element / 10) * 10 + 10
          }
        })
      }
      if (max >= 100) {
        max = 100
      }
      this.chart.setOption({
        xAxis: {
          type: 'category',
          // 隐藏刻度
          axisTick: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: '#999999'
            }
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize: '10', color: '#000'
            }
          },
          data: titleList
        },
        grid: {
          right: '20%',
          bottom: '10%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10],
          formatter: function (params) { // 弹窗内容
            // 弹窗里圆点的对应的样式，用模板字符串的方式
            let dotColor = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + params[0].color + '"></span>'
            let dotColor2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + params[1].color + '"></span>'
            // 弹窗里的内容+样式
            return '<span style="font-size:14px;font-weight: 600;color: #20253B">' + params[0].axisValue + '</span>' + '<br>' +
                   dotColor + '<span style="color: #20253B;">' + params[0].seriesName + '</span>' + '：' + (params[0].value) + '%' + '<br>' +
                   dotColor2 + '<span style="color: #20253B;">' + params[1].seriesName + '</span>' + '：' + (params[1].value) + '%'
          }
        },
        yAxis: {
          // 隐藏刻度
          axisTick: {
            show: false
          },
          // 隐藏轴线
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#000',
            formatter: (value) => {
              return value + '%'
            }
          },
          min: 0,
          max: 100,
          splitNumber: 10,
          // 设置虚线
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          nameTextStyle: {
            color: '#999999'
          }
        },
        toolbox: {
          // 添加一个toolbox配置
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {
              readOnly: false
            },
            magicType: {
              // 配置可以动态切换的类型：
              type: ['line', 'bar', 'stack']
            },
            restore: {},
            saveAsImage: {}
          }
        },
        legend: {
          orient: 'vertical', // 'horizontal'
          top: 20,
          right: 5,
          data: this.$i18n.locale === 'zh-cn' ? ['正常孕妇', '小于胎龄儿孕妇'] : ['Normal', 'SGA']
        },
        series: [
          {
            name: this.$i18n.locale === 'zh-cn' ? '正常孕妇' : 'Normal',
            itemStyle: {
              color: '#29F1FA',
              lineStyle: {
                color: '#29F1FA',
                width: 3
              }
            },
            barMaxWidth: 20,
            smooth: false,
            type: 'bar',
            data: dataList,
            animationDuration: 2800,
            animationEasing: 'cubicInOut'
          },
          {
            name: this.$i18n.locale === 'zh-cn' ? '小于胎龄儿孕妇' : 'SGA',
            itemStyle: {
              color: '#1890FF',
              lineStyle: {
                color: '#1890FF',
                width: 3
              }
            },
            barMaxWidth: 20,
            smooth: false,
            type: 'bar',
            data: dataList2,
            animationDuration: 2800,
            animationEasing: 'cubicInOut'
          }
        ]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
}

.header {
  width: 100%;
  background-color: #fff;
}

.ant-col {
  max-height: 60px !important;
}

.titleBox {
  padding-left: 20px;
  border-left: 4px solid #1890ff;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/home/components/SgaRiskRate.vue